module.exports = __webpack_public_path__ + "img/A61-20190408_04.58596d86.jpg";